import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BLOG_ROUTE } from "../../utils/constants";
import { BlogCardDiv } from "./styles";

export const BlogCard: FC<{ post_id: string; short_desc?: boolean }> = ({
  post_id,
  short_desc = false
}) => {
  const { t, i18n } = useTranslation(`blog/${post_id}`);
  const navigate = useNavigate();

  let allowedLang = t("lang", { returnObjects: true });
  interface ImageData {
    name: string;
    alt: string;
    position: number;
  }
  const images: ImageData[] = t("images", { returnObjects: true });

  if (!!allowedLang.length) {
    if (!allowedLang.includes(i18n.language === "gb" ? "gb" : i18n.language))
      return null;
  }

  return (
    <BlogCardDiv
      onClick={() =>
        navigate(`/${i18n.language}${BLOG_ROUTE.slice(5)}/${post_id}`)
      }
    >
      <img
        src={
          (process.env.PUBLIC_URL as string) + "/images/" + t(images[0]["name"])
        }
        alt={t(images[0]["alt"])}
        loading="lazy"
      />
      <h2>{t("title")}</h2>
      <p>{short_desc ? t("shotInfo").slice(0, 100) + "..." : t("shotInfo")}</p>
    </BlogCardDiv>
  );
};
